import { connect } from 'react-redux';
import { showRevenueModal } from '../../redux/actions/modals';
import BaseRevenueView from '../revenue/BaseRevenueView';
import { securityViewTypes, securityGraphOptions } from '../../helpers/revenue';
import revenue from '../../api/revenue';

class IncomeSecurityView extends BaseRevenueView {

  useGroupBy = true;
  viewTypes = securityViewTypes;
  isVariance = true;

  handleRefresh = () => {
    const { selectedOperator, selectedWeek, selectedVarianceType, selectedCategory, selectedViewType, selectedGroupBy, selectedRegion } = this.state
    this.setState({ activeRow: { optionShowDetails: false }, graph: { lines: [], data: [] }, loading: true }, () => {
      revenue.getIncomeSummary(selectedOperator, selectedWeek, selectedCategory, selectedViewType, selectedVarianceType, selectedGroupBy, selectedRegion).then(
        summary => this.setState({ summary, loading: false }),
        () => this.setState({ loading: false })
      );
    })
  }

  onDetailsClick = () => {
    const { activeRow, selectedOperator, selectedVarianceType } = this.state;
    this.props.showRevenueModal(activeRow, selectedOperator, this.isVariance, () => this.handleRefresh(), selectedVarianceType);
  }

  refreshGraph = () => {
    const { selectedWeek, selectedCategory, selectedGroupBy, selectedRegion, selectedViewType, selectedVarianceType, activeRow } = this.state;
    this.setState({ chartLoading: true }, () => {
      revenue.getIncomeGraph(activeRow.siteId, selectedWeek, selectedCategory, selectedViewType, selectedVarianceType, selectedGroupBy, selectedRegion).then(
        graph => this.setState({ graph, chartLoading: false }),
        () => this.setState({ chartLoading: false })
      );
    })
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    operators: state.operators.filter(x => x.value !== -1)
  }
}

export default connect(mapStateToProps, { showRevenueModal })(IncomeSecurityView);